import { useApolloClient } from '@apollo/client/react';
import { useEffect } from 'react';

import { apolloCacheSessionKeyState } from '@/auth/clerk/states/apolloCacheSessionKeyState';
import { useSetAtomState } from '@/ui/utilities/state/jotai/hooks/useSetAtomState';

type ClerkApolloCacheResetEffectProps = {
  sessionKey: string;
};

// Runs while the pages are unmounted (ClerkAuthGate shows a loading state):
// clearing the cache under mounted pages would empty the session they read.
// SessionGate then loads the session of the new workspace.
export const ClerkApolloCacheResetEffect = ({
  sessionKey,
}: ClerkApolloCacheResetEffectProps) => {
  const apolloClient = useApolloClient();
  const setApolloCacheSessionKey = useSetAtomState(apolloCacheSessionKeyState);

  useEffect(() => {
    void apolloClient.clearStore().then(() => {
      setApolloCacheSessionKey(sessionKey);
    });
  }, [apolloClient, sessionKey, setApolloCacheSessionKey]);

  return null;
};
